import {Link} from "react-scroll"

function Home() {
    return (
        <div className="home-body">
            <div className="home-header">
                <h1 className="hero-name">
                    Noppakun Anantakitthawon
                </h1>
            </div>
            <div className="home-header">
                <h2 className="hero-tagline">
                    iOS Developer &middot; 3+ years &middot; Bangkok
                </h2>
            </div>
            <div className="chip-container hero-stack">
                <span className="chip-item">Swift</span>
                <span className="chip-item">SwiftUI</span>
                <span className="chip-item">Flutter</span>
            </div>
            <div className="hero-actions">
                {/* public/Noppakun_Anantakitthawon_iOS_Developer.pdf — last synced from
                    Noppakun_Resume_2026.pdf on 2026-07-28. Re-copy after every résumé edit. */}
                <a className="hero-resume-btn" href="/Noppakun_Anantakitthawon_iOS_Developer.pdf" target="_blank" rel="noopener noreferrer">
                    Résumé (PDF)
                </a>
                <Link activeClass="active" smooth spy to="contact">
                <div>
                    <div className="reach-me-btn-box" id="reach-me-btn-box-left">
                    </div>
                    <div id="reach-me-btn">
                        <h2 id="reach-me-btn-label">
                            Reach me!
                        </h2>
                    </div>
                    <div className="reach-me-btn-box" id="reach-me-btn-box-right">
                    </div>
                </div>
                </Link>
            </div>
        </div>
    )
}

export default Home
